import React, { Component, Fragment, useEffect, useState, useCallback } from 'react';

import { httpsCallable } from "firebase/functions";
import { functions } from './../FirebaseUtils';

import {firestore} from './../FirebaseUtils';

import { doc, addDoc, setDoc, getDoc, getDocs, collection } from 'firebase/firestore';



function UnityFunctionsContainer(props) {

    // const [ provider, setProvider ] = useState();
    // const [ signer, setSigner ] = useState();
    // const [ tmcContract, setTmcContract ] = useState();
    // const [ landContract, setLandContract ] = useState();
    // const [ landNftContract, setLandNftContract ] = useState();
    
    const UNITYOBJECT = {
        ReceiverObjName: "Browser Interaction",
        ReceiverFuncName: "UnityReceiveCommandResult",

        BuyLandProgressReceiverFuncName: "UnityReceiveRequestBuyLandProgress",
        BuyLandResultReceiverFuncName: "UnityReceiveRequestBuyLandResult",
    }

    // Note that this function must be placed before useEffect below, otherwise you will get the error saying
    // Uncaught ReferenceError: Cannot access 'handleUnitySendCommand' before initialization
    const handleUnitySendCommand = useCallback((json) => {

        console.log(`handleUnitySendCommand json: ${json}`);

        const commandObject = JSON.parse(json);

        if (commandObject.command !== undefined) {
            switch(commandObject.command) {
                case "RequestUser":                     UnityRequestUser(commandObject.command); break;
                case "RequestCheckEmployeeIdExists":    UnityRequestCheckEmployeeIdExists(commandObject); break;
                case "RequestGetEmailByEmployeeId":     UnityRequestGetEmailByEmployeeId(commandObject); break;
                case "RequestSaveEmployeeDetails":      UnityRequestSaveEmployeeDetails(commandObject); break;
                case "RequestSaveUserDetails":          UnityRequestSaveUserDetails(commandObject); break;
                case "RequestGetUserDetails":           UnityRequestGetUserDetails(commandObject); break;
                case "RequestGetQuestions":             UnityRequestGetQuestions(commandObject); break;
                case "RequestSubmitUserAnswer":         UnityRequestSubmitUserAnswer(commandObject); break;
                case "RequestGetVideoUrl":              UnityRequestGetVideoUrl(commandObject); break;
                case "RequestSaveChat":                 UnityRequestSaveChat(commandObject); break;
                case "RequestLogLogin":                 UnityRequestLogLogin(commandObject); break;
                case "RequestTestResponse":             UnityRequestTestResponse(commandObject); break;
                case "RequestTestResponse2":            UnityRequestTestResponse2(commandObject); break;
                default:
                    console.warn('Unknown command: ' + commandObject.command);
                    props.sendMessage(UNITYOBJECT.ReceiverObjName, UNITYOBJECT.ReceiverFuncName, JSON.stringify({ command: commandObject.command, succeeded: false, errorCode: -1, error: 'Unknown command' }) ); //createResult(commandObject.command, false, "Unknown command", {})
                    break;
            }
        }
        else {
            console.log('Bad command');
        }

    }, []);

    useEffect(() => {
        console.log('unity container is about to add listeners');
        
        props.addEventListener("UnitySendCommand", handleUnitySendCommand);

        return () => {
            props.removeEventListener("UnitySendCommand", handleUnitySendCommand);
        };
    }, [ handleUnitySendCommand, firestore ]);

    function UnityRequestTestResponse(commandObject) {
        let result = {
            succeeded: true, 
            command: commandObject.command, 
            randomNumber: Math.random(),
            errorCode: 0, 
            error: null,
        };

        console.log(`UnityRequestTestResponse result:${JSON.stringify(result)}`);

        props.sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveTestResponse", JSON.stringify(result));
    }

    function UnityRequestTestResponse2(commandObject) {
        let result = {
            succeeded: true, 
            command: commandObject.command, 
            randomNumber: Math.random(),
            errorCode: 0, 
            error: null,
        };

        props.sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveTestResponse2", JSON.stringify(result));
    }

    function UnityRequestUser(command) {
        props.sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveSendUser", JSON.stringify({ succeeded: true, command: command, uid: 'ieoajsdfjeaojdlkaaa', email: 'aaa@test.com', errorCode: 0, error: null }));
        //props.sendMessage(UNITYOBJECT.ReceiverObjName, UNITYOBJECT.ReceiverFuncName, createResult(command, true, null, { uid: 'ieoajsdfjeaojdlkaaa', email: 'aaa@test.com' }));
    }

    async function UnityRequestCheckEmployeeIdExists(commandObject) {
        let exists = false;
        try {
            const employeeRef = doc(firestore, 'employees', commandObject.employeeId);
            const employeeDoc = await getDoc(employeeRef);
        
            if (employeeDoc.exists()) {
                exists = true; // Employee exists
            }
            else {
                exists = false; // Employee does not exist
            }
        }
        catch (error) {
            console.error("Error checking employee existence:", error);
            exists = false; // Handle error gracefully
        }

        props.sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveEmployeeIdExistsResult", JSON.stringify({ succeeded: true, command: commandObject.command, employeeId: commandObject.employeeId, exists: exists, errorCode: 0, error: null }));
    }

    async function UnityRequestGetEmailByEmployeeId(commandObject) {
        let result = {
            succeeded: true, 
            command: commandObject.command, 
            employeeId: commandObject.employeeId, 
            email: null, 
            errorCode: 0, 
            error: null,
        };

        try {
            const employeeRef = doc(firestore, 'employees', commandObject.employeeId);
            const employeeDoc = await getDoc(employeeRef);
        
            if (employeeDoc.exists()) {
                result.email = employeeDoc.data().email;
            }
        }
        catch (error) {
            console.error("Error getting email by employeeId:", error);

            result.succeeded = false;
            result.errorCode = -1;
            result.error = error;
        }

        props.sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveGetEmailByEmployeeIdResult", JSON.stringify(result));
    }

    async function UnityRequestSaveEmployeeDetails(commandObject) {
        const employeeDetails = {
            employeeId: commandObject.employeeId,
            name: commandObject.name,
            surname: commandObject.surname,
            email: commandObject.email
        };

        let result = {
            succeeded: true,
            command: commandObject.command,
            employeeId: commandObject.employeeId,
            name: commandObject.name,
            surname: commandObject.surname,
            email: commandObject.email,
            errorCode: 0, 
            error: null,
        }

        try {
            await setDoc(doc(firestore, "employees", commandObject.employeeId), employeeDetails);
            console.log("Document written with ID: ", commandObject.employeeId);
        } 
        catch (error) {
            console.error("Error adding document: ", error);

            result.succeeded = false;
            result.errorCode = -1;
            result.error = error;
        }
        props.sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveSaveEmployeeDetailsResult", JSON.stringify(result));

        // setDoc(doc(firestore, "employees", commandObject.employeeId), employeeDetails)
        // .then(() => {
        //     props.sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveSaveEmployeeDetailsResult", JSON.stringify(result));
        // })
        // .catch((error) => {
        //     result.succeeded = false;
        //     result.errorCode = -1;
        //     result.error = error;
        //     props.sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveSaveEmployeeDetailsResult", JSON.stringify(result));
        // });
    }

    async function UnityRequestSaveUserDetails(commandObject) {
        const userDetails = {
            name: commandObject.name,
            surname: commandObject.surname,
            email: commandObject.email
        };

        let result = {
            succeeded: true,
            command: commandObject.command,
            name: commandObject.name,
            surname: commandObject.surname,
            email: commandObject.email,
            errorCode: 0, 
            error: null,
        }

        try {
            await setDoc(doc(firestore, "users", commandObject.email), userDetails);
            console.log("Document written with ID: ", commandObject.email);
        } 
        catch (error) {
            console.error("Error adding document: ", error);

            result.succeeded = false;
            result.errorCode = -1;
            result.error = error;
        }

        props.sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveSaveUserDetailsResult", JSON.stringify(result));
    }

    async function UnityRequestGetUserDetails(commandObject) {
        let result = {
            succeeded: true,
            command: commandObject.command,
            email: commandObject.email,
            userDetails: null,
            errorCode: 0, 
            error: null,
        }

        try {
            const docRef = doc(firestore, 'users', commandObject.email);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                result.userDetails = docSnap.data();
            }
            else {
                console.log('No such document!');
                result.succeeded = false;
                result.errorCode = -2;
                result.error = 'No such document!';
            }

        } 
        catch (error) {
            console.error("Error retrieving document: ", error);

            result.succeeded = false;
            result.errorCode = -1;
            result.error = error;
        }

        props.sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveGetUserDetailsResult", JSON.stringify(result));
    }

    async function UnityRequestGetQuestions(commandObject) {
        const questionsRef = collection(firestore, 'questions');
        const querySnapshot = await getDocs(questionsRef);
        const fetchedQuestions = querySnapshot.docs.map((doc) => ({
            //id: doc.id,
            ...doc.data(),
        }));

        let result = {
            succeeded: true,
            command: commandObject.command,
            questions: fetchedQuestions,
            errorCode: 0, 
            error: null,
        }

        props.sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveGetQuestionsResult", JSON.stringify(result));
    }

    async function UnityRequestSubmitUserAnswer(commandObject) {
        let result = {
            succeeded: true,
            command: commandObject.command,

            errorCode: 0, 
            error: null,
        }

        try {
            await setDoc(doc(firestore, "usersAnswers", commandObject.docId), commandObject.userAnswers);
            console.log("Document written with ID: ", commandObject.docId);
        } 
        catch (error) {
            console.error("Error adding document: ", error);

            result.succeeded = false;
            result.errorCode = -1;
            result.error = error;
        }

        props.sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveSubmitUserAnswer", JSON.stringify(result));
    }

    async function UnityRequestGetVideoUrl(commandObject) {
        let result = {
            succeeded: true,
            command: commandObject.command,
            location: commandObject.location,
            url: null,

            errorCode: 0, 
            error: null,
        }

        try {
            const docRef = doc(firestore, 'videosSetup', commandObject.location);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const videoId = docSnap.data().videoId;

                const detailsDocRef = doc(firestore, 'videosDetails', videoId);
                const detailsDocSnap = await getDoc(detailsDocRef);
    
                if (detailsDocSnap.exists()) {
                    result.url = detailsDocSnap.data().url;

                    console.log(`result.url = ${result.url}`);
                }
                else {
                    console.log('No such video!');
                    result.succeeded = false;
                    result.errorCode = -3;
                    result.error = 'No such video!';
                }
            }
            else {
                console.log('No such document!');
                result.succeeded = false;
                result.errorCode = -2;
                result.error = 'No such document!';
            }
        } 
        catch (error) {
            console.error("Error adding document: ", error);

            result.succeeded = false;
            result.errorCode = -1;
            result.error = error;
        }

        props.sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveGetVideoUrl", JSON.stringify(result));
    }

    async function UnityRequestSaveChat(commandObject) {
        let result = {
            succeeded: true,
            command: commandObject.command,
            docId: commandObject.docId,
            data: commandObject.data,

            errorCode: 0, 
            error: null,
        }

        try {
            await setDoc(doc(firestore, "chatLogs", commandObject.docId), commandObject.data);
            console.log("Document written with ID: ", commandObject.docId);
        } 
        catch (error) {
            console.error("Error adding document: ", error);

            result.succeeded = false;
            result.errorCode = -1;
            result.error = error;
        }

        props.sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveSaveChatResult", JSON.stringify(result));
    }

    async function UnityRequestLogLogin(commandObject) {
        let result = {
            succeeded: true,
            command: commandObject.command,
            logData: commandObject.logData,

            errorCode: 0, 
            error: null,
        }

        try {
            await addDoc(collection(firestore, "loginLogs"), commandObject.logData);
        } 
        catch (error) {
            console.error("Error adding document: ", error);

            result.succeeded = false;
            result.errorCode = -1;
            result.error = error;
        }

        props.sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveLogLoginResult", JSON.stringify(result));
    }

    async function wait2secs() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve();
            }, 2000);
        });
    }

    return (
        <div>
        </div>
    );
}

export default UnityFunctionsContainer;
